import { AppState } from '../reducers/root';
import { ActionProgressState } from '../slices/actionProgress';

export const getActionProgressState = (
  state: AppState
): ActionProgressState | null => state.actionProgress;

export const hasActiveActionProgress = (state: AppState): boolean =>
  state.actionProgress !== null;

export const hasActiveCancellableActionProgress = (state: AppState): boolean =>
  !!state.actionProgress?.cancellable;
